import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import PopularSection from './components/PopularSection';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '汗汗漫画',
  url: 'https://www.hanhanmanga.com',
  description: '汗汗漫画是专业的免费韩国漫画在线阅读平台，提供海量优质韩漫资源，更新及时，访问流畅，是您休闲时光的可靠伴侣。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.hanhanmanga.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '汗汗漫画',
  url: 'https://www.hanhanmanga.com',
  description: '免费韩国漫画在线阅读平台',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@hanhanmanga.com',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="汗汗漫画 - 免费韩国漫画,韩漫在线,看漫画网站"
        description="汗汗漫画是专业的看漫画网站，提供免费韩国漫画和韩漫在线服务，资源稳定，访问流畅。涵盖恋爱、奇幻、热血、剧情、搞笑、悬疑等多种类型韩漫，是您休闲时光的可靠伴侣。每日更新，畅享优质漫画阅读体验。"
        keywords="汗汗漫画,免费韩国漫画,韩漫在线,看漫画网站,韩漫,韩国漫画在线阅读,免费漫画"
        canonicalPath="/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20reading%20website%20banner%20with%20colorful%20comic%20art%20style%20background%2C%20various%20characters%20from%20different%20genres%2C%20warm%20inviting%20atmosphere%2C%20digital%20reading%20platform%20concept%2C%20clean%20modern%20layout&width=1200&height=630&seq=home-og-image&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <HeroSection />
      <PopularSection />
      <CategorySection />
      <LatestUpdates />
      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-4">
              为什么选择汗汗漫画？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-speed-up-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">资源稳定</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">高速服务器保障流畅阅读体验，图片加载快速稳定</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-book-open-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">海量资源</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">收录海量优质韩漫资源，每日持续更新最新章节</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-device-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">多端适配</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">电脑手机平板完美适配，随时随地畅享漫画乐趣</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}